const styleShopifyForms = () => {
  const styleProps = {
    '--body-text-color': 'currentColor',
    '--heading-text-color': 'currentColor',
    '--form-placeholder-color': 'currentColor',
    '--form-text-color': 'currentColor',
    '--form-background-color': 'white',
    '--form-field-border-radius': '0px',
    '--button-border-radius': '99px',
    '--forms-body-font': '16px degular, sans-serif',
    '--forms-heading-font': '700 19px degular, sans-serif',
    '--button-background-color': 'var(--color-blue-800)',
    '--button-text-color': 'var(--color-white)',
  }

  Object.entries(styleProps).forEach(([name, value]) => {
    document.querySelector('shopify-forms-embed').shadowRoot.firstChild.style.setProperty(name, value)
  });
}

const observer = new MutationObserver((mutations, obs) => {
  const el = document.querySelector('shopify-forms-embed');
  if (el) {
    styleShopifyForms();
    obs.disconnect();
  }
});

customElements.whenDefined('shopify-forms-embed').then(() => {
  observer.observe(document.body, { childList: true, subtree: true });
});
